<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        xl="9"
        class="order-last order-xl-first"
      >
        <v-card>
          <v-card-title class="pb-8">
            <v-btn
              color="primary"
              @click="createDialog = true"
            >Nuova nota</v-btn>
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="noteList"
              :items-per-page="100"
              :search="search"
              :footer-props="{
						itemsPerPageAllText: 'Tutte',
						itemsPerPageOptions: [15, 50, 100, -1],
						itemsPerPageText: 'Note per pagina',
					}"
              class="table"
            >
              <template v-slot:item.action="{ item }">
                <td class="actions">
                  <v-btn
                    color="green"
                    elevation="1"
                    outlined
                    small
                    @click.stop="confirmHandler('archive', item.id)"
                    v-if="item.state == 0"
                  >
                    <v-icon small>
                      mdi-archive
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="orange"
                    elevation="1"
                    outlined
                    small
                    @click.stop="showEdit(item)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="red"
                    elevation="1"
                    outlined
                    small
                    @click.stop="confirmHandler('delete', item.id)"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </td>
              </template>

              <template v-slot:no-data>
                <div class="pa-3">
                  <p>Nessuna nota. Prova ad impostare dei parametri differenti per i filtri oppure a ricaricare.</p>
                  <v-btn
                    color="primary"
                    @click="fetchNotes"
                  >Ricarica</v-btn>
                </div>
              </template>
              <template v-slot:item.note="{ item }">
                <div style="padding: 1.5rem 1rem 1rem 0; border-right: 1px solid rgba(255, 255, 255, 0.12);">
                  <h2>{{ item.title }}</h2>
                  <br />
                  <p
                    style="margin: 0; text-align: justify;"
                    v-html="item.body "
                  ></p>
                </div>
              </template>
              <template v-slot:item.deadline="{ item }">
                <span>{{ item.deadline ? formatDate(item.deadline) : '' }}</span>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span>{{ formatDate(item.created_at) }}</span>
              </template>
              <template v-slot:item.priority="{ item }">
                <span
                  class="green--text"
                  v-if="item.priority == 0"
                >Bassa</span>
                <span
                  class="orange--text"
                  v-else-if="item.priority == 1"
                >Media</span>
                <span
                  class="red--text"
                  v-else-if="item.priority == 2"
                >Alta</span>
              </template>
              <template v-slot:item.assignee="{ item }">
                <span
                  class="blue--text"
                  v-if="isMine(item.assignee)"
                >{{ item.assignee }}</span>
                <span v-else>{{ item.assignee }}</span>
              </template>
              <template v-slot:item.author="{ item }">
                <span
                  class="blue--text"
                  v-if="isMine(item.author)"
                >{{ item.author }}</span>
                <span v-else>{{ item.author }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <filters
          :priorities="priorityList"
          :assignees="usersList"
          :authors="usersList"
        />
      </v-col>
    </v-row>

    <!-- create dialog -->

    <v-row>
      <create-dialog
        :dialog="createDialog"
        @dismiss="createDialog = false"
        @saved="savedHandler"
        :users="usersList"
        :priorities="priorityList"
      />
    </v-row>

    <!-- edit dialog -->

    <v-row>
      <edit-dialog
        :dialog="editDialog"
        @dismiss="editDialog = false"
        @edit="editHandler"
        :users="usersList"
        :priorities="priorityList"
        :item="item"
      />
    </v-row>

    <!-- confirm dialog -->

    <v-row justify="center">
      <v-dialog
        v-model="confirmDialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">{{ confirmDialogData.title }}</v-card-title>

          <v-card-text>
            {{ confirmDialogData.message }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="confirm = true"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="confirmDialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapActions, mapGetters } from 'vuex'

  import CreateDialog from '../components/note/CreateDialog'
  import EditDialog from '../components/note/EditDialog'
  import Filters from '../components/note/Filters'

  export default {
    name: 'Note',
    components: {
      CreateDialog,
      EditDialog,
      Filters
    },

    data() {
      return {
        usersList: [],
        priorityList: [
          { value: '0', text: 'Bassa' },
          { value: '1', text: 'Media' },
          { value: '2', text: 'Alta' },
        ],
        search: '',
        headers: [
          { text: 'Dettagli', value: 'note', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Priorità', value: 'priority', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Deadline', value: 'deadline', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Assegnata a', value: 'assignee', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Creata da', value: 'author', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: 'Creata il', value: 'created_at', class: 'subtitle-2 primary--text font-weight-bold' },
          { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' },
        ],
        confirm: false,
        confirmDialog: false,
        confirmDialogData: {
          id: '',
          mode: '',
          title: '',
          message: '',
        },
        createDialog: false,
        editDialog: false,
        item: {},
        config: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },

    methods: {
      ...mapActions(['fetchNotes', 'archiveNote', 'deleteNote']),
      formatDate(date) {
        return new Date(date).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
      },

      isMine(name) {
        return name == localStorage.getItem('username')
      },

      showEdit(item) {
        this.item = item
        this.editDialog = true
      },

      savedHandler() {
        this.fetchNotes()
        this.createDialog = false
      },

      editHandler() {
        this.fetchNotes()
        this.editDialog = false
      },

      confirmHandler(mode, id) {
        this.confirmDialogData.id = id

        switch (mode) {
          case 'archive':
            this.confirmDialogData.mode = 'archive'
            this.confirmDialogData.title = 'Archiviare Nota?'
            this.confirmDialogData.message = 'Confermando, la nota verrà contrassegnata come archiviata.'
            break
          case 'delete':
            this.confirmDialogData.mode = 'delete'
            this.confirmDialogData.title = 'Eliminare Nota?'
            this.confirmDialogData.message = 'Confermando, la nota verrà eliminata definitivamente dal database.'
            break
          default:
            return
        }

        this.confirmDialog = true
      },

      deleteHandler(id) {
        this.deleteNote({ id }).then((status) => {
          if (status) {
            this.fetchNotes()
          }
        })
      },

      archiveHandler(id) {
        this.archiveNote({ id }).then((status) => {
          if (status) {
            this.fetchNotes()
          }
        })
      },

      resetDialogData() {
        this.confirmDialogData = {
          id: '',
          mode: '',
          title: '',
          message: '',
        }
      },

      async fetchUsers() {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/users/fetch`, this.config)
        this.usersList = data.map((el) => {
          return { value: el.username, text: el.username }
        })
        this.usersList.unshift({ value: null, text: 'Nessuno' })
      },
    },

    watch: {
      confirm(val) {
        if (val) {
          switch (this.confirmDialogData.mode) {
            case 'archive':
              this.archiveHandler(this.confirmDialogData.id)
              break
            case 'delete':
              this.deleteHandler(this.confirmDialogData.id)
              break
            default:
              return
          }
        }

        this.confirm = false
        this.confirmDialog = false
        this.resetDialogData()
      }
    },

    computed: {
      ...mapGetters({
        noteList: 'getNotes',
      }),
    },

    mounted() {
      this.fetchNotes()
      this.fetchUsers()
    },
  }
</script>

<style>
  td {
    max-width: 25vw;
  }

  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>
